var map = {
	"./ambassade.png": "dbfd",
	"./avion.png": "4227",
	"./background_player_card.png": "49f6",
	"./banque.png": "92eb",
	"./base militaire.png": "8155",
	"./boîte de nuit.png": "4d14",
	"./carnaval.png": "c601",
	"./casino.png": "6d82",
	"./centre de thalasso.png": "cf62",
	"./cirque.png": "8372",
	"./croisade.png": "2373",
	"./ecole.png": "8b21",
	"./espion.png": "359c",
	"./fête d'entreprise.png": "60ac",
	"./garage.png": "cea4",
	"./generic.png": "6246",
	"./hôpital.png": "4c0a",
	"./hôtel.png": "0700",
	"./logo.png": "cf05",
	"./logo_off.png": "f258",
	"./paquebot.png": "0427",
	"./parc d'attraction.png": "26b6",
	"./plage.png": "0b81",
	"./poste de police.png": "f561",
	"./restaurant.png": "c9eb7",
	"./sous-marin.png": "5791",
	"./station polaire.png": "dbe9",
	"./station spatiale.png": "b3f3",
	"./studio de cinéma.png": "d5ba",
	"./supermarché.png": "18e1",
	"./théâtre.png": "3d6f",
	"./train de voyageur.png": "7442",
	"./université.png": "e5ad",
	"./zoo.png": "de56"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";